import React, { Component } from "react";
import history from "../../login/history"
import { trackPromise, promiseTrackerHoc } from 'react-promise-tracker';
import DebitoAutomaticoService from "../../../../services/autogestion/DebitoAutomaticoService";
import Popup from "react-popup";
import authService from "../../../../services/login/auth.service";
import ConfigService from "../../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";


export default class AgregarPaso2 extends Component {
  constructor(props) {
    super(props);    
    this.state = this.getInitialState();    
  }

  notifiPopup = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });


  getInitialState = () => ({
    datosCuenta:[]
  })  

  componentDidMount() {
 
  }

  getColumn() {
    return [
    {
      name: "concepto",
      selector: row => row.concepto,
    },
    {
      name: "valor",
      selector: row => row.valor,
    }]
  }

  

  volverDebitoAutomatico = (e) => {
    //history.push('/debitoAutomatico');
    history.push(ConfigService.getPathByName("debitoAutomatico")?.url);
    window.location.reload();
  }
  continuar = () => {
    var documento = null;
    var importe = null;
    var porcentaje = null;
    if(this.props.rptPaso1.nroModalidad === "10"){
      documento = this.props.rptPaso1.TC_nro
      importe = null
      porcentaje = this.props.rptPaso1.TC_porcentaje
    
    }
    if(this.props.rptPaso1.nroModalidad === "11"){
      documento = this.props.rptPaso1.AH_ahorro
     
    }
    if(this.props.rptPaso1.nroModalidad === "14"){
      documento = this.props.rptPaso1.RUE_idAhorro
     
    }

    if(this.props.rptPaso1.nroModalidad === "7"){
      documento = this.props.rptPaso1.PRE_credito
     
    }

   
    trackPromise(

      DebitoAutomaticoService.confirmarDebitoAutomatico(this.props.cuenta, this.props.rptPaso1.nroModalidad, documento, importe, porcentaje)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigo === 0) {
           
            this.props.respuestaPaso2(jsonData.datos, this.props.rptPaso1, this.props.modalidad);
          
            this.nextStep.click();
          }
          else {
           // this.setState({ ahorros: undefined });
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }

        }
        ));
    
}
  render() {
  
    if( this.props.rptPaso1 === undefined)
    return(<span />)
    //var respuesta = this.props.rptPaso1
   //console.log(this.props.rptPaso1.TC_porcentaje)
      return (
            <div>
              <div className="row">
                <div className="steps clearfix">
                  <ul role="tablist">
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">
                          <span className="title_text">
                            Selección de Cuenta
                          </span>
                        </div>
                      </span>
                    </li>
                    <li role="tab" className="current">
                      <span>
                        <div className="title">
                          <span className="title_text">
                            Datos de Verificación
                          </span>
                        </div>
                      </span>
                    </li>
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">
                          <span className="title_text">Confirmación</span>
                        </div>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>


              <div className="row justify-content-md-center">
                <div className="col-lg-8 col-md-10">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="input-label">Modalidad:</label><br/> 
                        <label className="input-label-bold"> {this.props.rptPaso1.modalidad}</label>
                      </div>
                    </div>  
                  </div> 
                  <div className="row">  
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="input-label">Cuenta Origen (a debitar):</label><br/> 
                        <label className="input-label-bold"> {this.props.rptPaso1.cuenta_debito}</label>                    
                      </div>
                    </div>
                    
                   
                    <div className="col-md-6"> 
                    {this.props.rptPaso1.nroModalidad === "10" ?
                      <div className="form-group">
                        <label className="input-label">Cuenta a Acreditar:</label><br/> 
                        <label className="input-label-bold"> {this.props.rptPaso1.TC_tarjeta} - {this.props.rptPaso1.TC_tipo}</label>                    
                      </div>:
                       <div className="form-group">
                       <label className="input-label">Cuenta a Acreditar:</label><br/> 
                       <label className="input-label-bold">{this.props.rptPaso1.cuenta_credito}</label>                    
                     </div>}
                    </div>  
                  </div>
                  {this.props.rptPaso1.nroModalidad === "10" && this.props.rptPaso1.TC_porcentaje === "5" ?
                  <div className="row" >   
                    <div className="col-md-12"> 
                      <h6>
                        Importe a Pagar: 5% de la deuda
                      </h6>
                    </div>
                  </div>: <div className="row" ></div> }
                  {this.props.rptPaso1.nroModalidad === "10" && this.props.rptPaso1.TC_porcentaje === "100" ?
                  <div className="row" >   
                    <div className="col-md-12"> 
                      <h6>
                        Importe a Pagar: 100% de la deuda (Saldo al cierre)
                      </h6>
                    </div>
                  </div>: <div className="row" ></div> }
                </div>   
              </div>  
              
              <hr/>
              <div className="row">
                <div className="col-lg-8 col-md-6 col-12">
                <label className="input-label-bold" style={{marginTop:10}}>
                      Esta seguro que desea CONFIRMAR la operación?<br/>
                    </label> 
                </div>
                <div className="col-lg-2 col-md-3">
                <button className="btn btn-cu-quintary btn-consulta"
                       onClick={this.props.previousStep}>
                      <FontAwesomeIcon icon={faArrowLeft} /> Volver
                    </button>
                </div>
                <div className="col-lg-2 col-md-3">
                <button className="btn btn-cu-primary" 
                      onClick={() => {this.continuar()}}> Confirmar <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                    <button
                      hidden
                      ref={(a) => (this.nextStep = a)}
                      className="btn btn-cu-primary"
                      onClick={this.props.nextStep}>
                    </button>
                </div>
              </div>

          </div>  
      );
  }
}